const getPrice = arr => {
  if (arr.length === 1) {
    return `Từ ${arr[0].price} `
  } else {
    let max = Math.max(arr.price)
    let min = Math.min(arr.price)
    return `Từ ${min} đến ${max}`
  }
}

export const textHelpers = {
  removeSpaces(str) {
    return (str || '').trim().replace(/\s+/g, ' ')
  },
  getNumber(str) {
    return (str || '').trim().replace(/[^0-9]/g, '')
  },
  getLastName(str) {
    return (str || '')
      .split(' ')
      .slice(-1)
      .join(' ')
  },
  getCategory(str) {
    if (str === 'custom') return 'Bổ sung'
    else if (str === 'default') return 'Mặc định'
    else return ''
  },
  getListHeadFee(arr) {
    let list = []
    for (let item of arr) {
      let price = getPrice(item.prices)
      list.push({
        title: item.head_fee.title,
        category: item.head_fee.category,
        price: price
      })
    }
    return list
  },
  sortGroupFee(arr) {
    let list1 = []
    let list2 = []
    let list3 = []
    let list4 = []
    arr.map(group => {
      switch (group.defaultType) {
        case 'all':
          list1.push(group)
          break
        case 'grade':
          list2.push(group)
          break
        case 'class':
          list3.push(group)
          break
        default:
          list4.push(group)
          break
      }
    })
    list2.sort((a, b) => +a.tags.replace('Khoi ', '') - +b.tags.replace('Khoi ', ''))
    list4.sort(function(a, b) {
      var textA = a.tags.toUpperCase()
      var textB = b.tags.toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0
    })
    function cutString(string) {
      const regex = /(^\d+)/gm
      let result = regex.exec(string)
      if (result) {
        return result[0]
      } else {
        return 13
      }
    }
    list3.sort((a, b) => cutString(a.tags) - cutString(b.tags))
    let list = list1.concat(list2, list3, list4)
    return list
  },
  getKeyBusSchedule(periodTime, direction) {
    if (periodTime === 'AM' && direction === 'in') {
      return 0
    } else if (periodTime === 'AM' && direction === 'out') {
      return 1
    } else if (periodTime === 'PM' && direction === 'in') {
      return 2
    } else if (periodTime === 'PM' && direction === 'out') {
      return 3
    }
  }
}
